// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_gridWrapper__bpqDt {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 24px;
}
@media (max-width: 768px) {
  .styles_gridWrapper__bpqDt {
    grid-template-columns: 1fr;
  }
}

.styles_inputWrapper__GH1GV {
  width: 100%;
  display: flex;
  gap: 24px;
}
@media (max-width: 1920px) {
  .styles_inputWrapper__GH1GV {
    display: grid;
    grid-template-columns: 1fr 4fr;
  }
}
@media (max-width: 768px) {
  .styles_inputWrapper__GH1GV {
    grid-template-columns: 1fr;
  }
}

.styles_totalWrapper__-bTUo {
  width: 100%;
  max-width: 334px;
}

.styles_inputValueWrapper__MAtOQ {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
@media (max-width: 768px) {
  .styles_inputValueWrapper__MAtOQ {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TokenCreator/content/tokenCreation/baseContent/burningContent/detailsInput/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,qCAAA;EACA,cAAA;AADF;AC2BE;ED7BF;IAMI,0BAAA;EAAF;AACF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,SAAA;AAAF;ACdE;EDWF;IAMI,aAAA;IACA,8BAAA;EACF;AACF;ACUE;EDnBF;IAWI,0BAAA;EAEF;AACF;;AACA;EACE,WAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,qCAAA;AAEF;ACLE;EDCF;IAKI,0BAAA;EAGF;AACF","sourcesContent":["@import './src/assets/styles/mixin/breakpoints';\n\n.gridWrapper {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 24px;\n\n  @include md {\n    grid-template-columns: 1fr;\n  }\n}\n\n.inputWrapper {\n  width: 100%;\n  display: flex;\n  gap: 24px;\n\n  @include xxxxl {\n    display: grid;\n    grid-template-columns: 1fr 4fr;\n  }\n\n  @include md {\n    grid-template-columns: 1fr;\n  }\n}\n\n.totalWrapper {\n  width: 100%;\n  max-width: 334px;\n}\n\n.inputValueWrapper {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n\n  @include md {\n    grid-template-columns: 1fr;\n  }\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridWrapper": `styles_gridWrapper__bpqDt`,
	"inputWrapper": `styles_inputWrapper__GH1GV`,
	"totalWrapper": `styles_totalWrapper__-bTUo`,
	"inputValueWrapper": `styles_inputValueWrapper__MAtOQ`
};
export default ___CSS_LOADER_EXPORT___;
